import { Expose } from "class-transformer";

export class UpdateElementDto {
  @Expose()
  name: string;
}
